import { getModuleProps } from 'src/workspace/utils';

export const getColumns = (workflowConfig) => {
  const { columnConfigs = [] } = workflowConfig;
  const columns = columnConfigs.filter(({ visible }) =>
    (visible?.enabledFor || [])?.includes('web'),
  );

  return columns;
};

export const getCachedEntities = (workflow) => {
  const workflowList = getModuleProps()?.getRevyreReferrals()?.[workflow] ?? [];
  const entities = workflowList.map((listItem) => listItem?.mutatedEntity);

  return entities;
};
